import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { Environment } from '../types/Environment';
export const buildHubletUrlOverride = hublet => {
  if (hublet !== 'na1') {
    return url => `${getFullUrl('app-api', {
      hubletOverride: hublet
    })}${url}`;
  }

  return url => url;
};

const getHubletUrl = (subDomainPrefix, hublet) => {
  const overrideConfig = {};

  if (hublet) {
    overrideConfig.hubletOverride = hublet;
  }

  return getFullUrl(subDomainPrefix, overrideConfig);
};

export const getHubletAppUrl = hublet => getHubletUrl('app', hublet);
export const getHubletApiUrl = hublet => getHubletUrl('app-api', hublet);
export const getAppUrl = () => {
  const prefix = !enviro.deployed() ? Environment.Local : 'app';
  return getFullUrl(prefix, {});
};